// extracted by mini-css-extract-plugin
export var csatScore = "_jd-5";
export var header = "_jd-1";
export var panelWrapper = "_jd-2";
export var postPreview = "_jd-3";
export var rightContent = "_jd-0";
export var wrappingText = "_jd-4";